module.exports = __webpack_public_path__ + "img/add_from_SC.7efbcc49.png";